export interface ApiMessage {
  message: string,
  severity: ApiMessageSeverityValues,
  type: ApiMessageTypeValues,
}

export enum ApiMessageType {
  global = 'global',
  local = 'local',
}

export type ApiMessageTypeValues = `${ApiMessageType}`

export enum ApiMessageSeverity {
  success = 'success',
  info = 'info',
  warn = 'warn',
  error = 'error',
}

export type ApiMessageSeverityValues = `${ApiMessageSeverity}`;

export const ApiMessageSummary = {
  [ApiMessageSeverity.success]: 'Success',
  [ApiMessageSeverity.info]: 'Information',
  [ApiMessageSeverity.warn]: 'Warning',
  [ApiMessageSeverity.error]: 'Error',
};
